import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { Row, Col, Button } from 'reactstrap';

//Constants
import { actionsTable } from '../../../../../constants/MaterialTable';
//Components
import TabelaListagem from '../../../../../components/TabelaListagem/TabelaListagem';
import ModalCustomized from '../../../../../components/Modal/Modal';
import TextField from '../../../../../components/TextField';

//Helpers
import uuid from '../../../../../helpers/guid';
import { validarCampos, objCampo } from '../../../../../helpers/ValidadorDeCampos';
import { showMessage, showQuestion } from '../../../../../helpers/message';

//api
import formulario_api from '../../../../../api/formulario_api';
import documento_api from '../../../../../api/documento_api';
import modelosEmail_api from '../../../../../api/modelosEmail_api';
import tipoRequerimento_api from '../../../../../api/tipoRequerimento_api';

//Context
import { useAuth } from '../../../../../context/auth';

function initialStateEtapa(uuid) {
    return {
        identificacao: "",
        prazoDias: "",
        responsavel: "",
        excluido: "false",
        final: "false",
        inicial: "false",
        permitirProrrogar: "true",
        hash: uuid,
        tipoRequerimentoEtapaDocumentos: [],
        modeloEmail_Id: null,
        orientacoes: "",
        formularioAPP_Id: "",
        informarTipoCompensacao: "false",
        informarNumeroProcesso: "false",
        gerarAgendamentoReplantio: "false"
    }
}

const initialStateDocumento = (idTipoRequerimentoEtapa) => {
    return {
        ...idTipoRequerimentoEtapa ? { tipoRequerimentoEtapa_Id: idTipoRequerimentoEtapa } : {},
        documento_Id: "",
        obrigatorio: "",
    }
}

export default function Etapas({ tipoRequerimento, loadEtapas, editavel }) {
    //Estado de controle dos erros nos campos obrigatorios de cadastro de etapa
    const [errors, setErrors] = useState({});

    //Estado de controle dos erros nos campos do documento
    const [errorsDocumento, setErrosDocumento] = useState({});

    //Estado de controle da lista de formularios de vistoria
    const [formularios, setFormularios] = useState([]);

    const { setLoading } = useAuth();

    //Estado de controle de visibilidade do modal dos documentos
    const [visibleModal, setVisibleModal] = useState(false);

    //Estado de controle de visibilidade do formulario de cadastro de etapa
    const [visibleContainer, setVisibleContainer] = useState(false);

    //Função de troca de visibilidade do modal
    const toggleModal = () => {
        setVisibleModal(!visibleModal);
    };

    //Estado de controle de troca de exibição do formulario de cadastro de etapa
    const toggleFormContainer = () => {
        setVisibleContainer(!visibleContainer);
        if (visibleContainer) {
            setCamposObrigatorios(camposObrigatorios.filter(value => value.name != "formularioAPP_Id"));
            setEtapa(initialStateEtapa(uuid()));
        }
    }

    //Estado de controle dos dados da etapa
    const [etapa, setEtapa] = useState(initialStateEtapa(uuid()));

    //Estado de controle dos dados do documento a ser adicionado na lista
    const [documento, setDocumento] = useState(initialStateDocumento(etapa.id));

    //Estado de controle das opções de documentos
    const [documentos, setDocumentos] = useState([]);

    //Campos obrigatorios
    const [camposObrigatorios, setCamposObrigatorios] = useState([
        objCampo({ name: "identificacao", required: true }),
        objCampo({ name: "responsavel", required: true }),
        objCampo({ name: "inicial", required: true }),
        objCampo({ name: "final", required: true }),
    ]);
    //Campos obrigatorios
    const camposDocumento = [
        objCampo({ name: "documento_Id", required: true }),
        objCampo({ name: "obrigatorio", required: true }),
    ];

    //onChange para o documento a ser adicionado
    const onChangeDocumento = (value, e) => {
        setDocumento({
            ...documento,
            [e.name]: value ? value.value : null,
        });

    }
    //onChange do campo obrigatorio do documento
    const onChangeObrigatorioDocumento = (e) => {
        const { name, value } = e.target;

        setDocumento({
            ...documento,
            [name]: value
        })
    }

    //Função de salvamento dos insert do documento
    const onSubmitDocumento = () => {
        const _documento = { ...documento };

        const _errorsDocumento = validarCampos(_documento, camposDocumento);
        setErrosDocumento(_errorsDocumento[0]);
        if (_errorsDocumento[1].length > 0)
            return;

        if (etapa.tipoRequerimentoEtapaDocumentos.filter(x => x.documento_Id == _documento.documento_Id && (!_documento.id || _documento.id != x.id)).length > 0) {
            showMessage("Aviso", "Este documento ja foi adicionado para este tipo de requerimento", "info", null);
            return;
        }
        const _tipoRequerimentoDocumentos = [...!_documento.id
            ? etapa.tipoRequerimentoEtapaDocumentos
            : etapa.tipoRequerimentoEtapaDocumentos.map(value => {
                if (value.id == _documento.id)
                    return _documento;
                return value;
            })];

        if (!_documento.id) {
            _tipoRequerimentoDocumentos.push(_documento);
        }

        setEtapa({
            ...etapa,
            tipoRequerimentoEtapaDocumentos: _tipoRequerimentoDocumentos
        });
        setDocumento(initialStateDocumento(etapa.id));
    }

    //Função do botão de editar etapa
    const editar = (etapa) => {
        if (etapa.responsavel == "Fiscal") {
            setCamposObrigatorios([...camposObrigatorios, objCampo({ name: "formularioAPP_Id", required: true })]);
        }
        loadEtapa(etapa.id);
        setVisibleContainer(true);
    }

    //Função do botão de remover etapa
    const remover = (etapaRemove) => {
        showQuestion("Tem certeza?", "tem certeza de que deseja deletar essa etapa?\n Esta ação é irreversível", "info",
            (confirmation) => {
                if (confirmation) {
                    setLoading(true);
                    tipoRequerimento_api.deleteTipoRequerimentoEtapa(etapaRemove.id).then(response => {
                        showMessage("Sucesso", "Etapa removida com sucesso!", "success", loadEtapas);
                    }).catch(e => showMessage("Erro", e.message, "error", null))
                        .finally(f => setLoading(false));
                }
            })
    }

    //Ações que a tabela terá
    const actions = [
        ...editavel ?
            [actionsTable.editar(editar),
            actionsTable.remover(remover)]
            : [actionsTable.visualizar(editar)]
    ];
    const editarDocumento = (editRow) => {
        setDocumento(editRow);
    }
    const removerDocumento = (questaoRemove) => {
        showQuestion("Tem certeza?", "tem certeza de que deseja deletar esse documento?\n Esta ação é irreversível", "info",
            (confirmation) => {
                if (confirmation) {
                    setEtapa({
                        ...etapa,
                        tipoRequerimentoEtapaDocumentos: etapa.tipoRequerimentoEtapaDocumentos.filter(value => value.tableData.id != questaoRemove.tableData.id)
                    });
                }
            })
    }

    //Actions da tabela de documentos
    const actionsDocumentos = [
        ...editavel ?
            [actionsTable.editar(editarDocumento),
            actionsTable.remover(removerDocumento)]
            : []
    ]

    //Cabeçalhos que a tabela terá
    const headers = [
        { value: "Identificação", objectValue: "identificacao", align: "left" },
        { value: "Prazo em dias", objectValue: "prazoDias", align: "left" },
        { value: "Responsavel", objectValue: "responsavel", align: "left" },
        { value: "Sequencia", objectValue: "sequencia", align: "left" },
    ]
    //Cabeçalhos que a tabela de documentos terá
    const headersDocumentos = [
        {
            value: "Documento", objectValue: "documento_Id", align: "left", options: {
                filter: false,
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <div>
                            {documentos.filter(documento => documento.id == etapa.tipoRequerimentoEtapaDocumentos[dataIndex].documento_Id)[0].identificacao}
                        </div>
                    )
                }
            },
        },
        {
            value: "Obrigatorio", objectValue: "obrigatorio", align: "left", options: {
                filter: false,
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <div>
                            {etapa.tipoRequerimentoEtapaDocumentos[dataIndex].obrigatorio == "true" ? "Sim" : "Não"}
                        </div>
                    )
                }
            }
        }
    ]

    //onChange dos campos normais de cadastro da etapa
    const onChange = (e) => {
        const { name, value } = e.target;

        if (name == "final" && value == "false") {
            setEtapa({
                ...etapa,
                "gerarAgendamentoReplantio": "false",
                [name]: value
            });
        } else {
            setEtapa({
                ...etapa,
                [name]: value
            });
        }
    }
    //onChange do campo de responsavel pela etapa
    const onChangeResponsavel = (e) => {
        const { name, value } = e.target;
        if (value == "Fiscal") {
            setCamposObrigatorios([...camposObrigatorios, objCampo({ name: "formularioAPP_Id", required: true })]);
        } else {
            setCamposObrigatorios(camposObrigatorios.filter(value => value.name != "formularioAPP_Id"));
        }
        setEtapa({
            ...etapa,
            [name]: value
        });
    }
    //Carrega os documentos para o cadastro da etapa
    const loadDocumentos = () => {
        setLoading(true);
        documento_api.getList("Ativo").then(response => {
            setDocumentos(response.data.map(value => {
                value.id = value.id.toString();
                return value;
            }));
        }).catch(e => showMessage("Erro", e.message, "error", null))
            .finally(f => setLoading(false));
    }

    //Carrega os formularios para o cadastro das ações
    const loadFormularios = () => {
        setLoading(true);
        formulario_api.getList({ status: "Ativo", finalidade: "Vistoria" }).then(response => {
            setFormularios(response.data);
        }).catch(e => showMessage("Erro", e.message, "error", null))
            .finally(f => setLoading(false));
    }

    //Carrega a etapa pelo id
    const loadEtapa = (id) => {
        setLoading(true);
        tipoRequerimento_api.GetTipoRequerimentoEtapa(id).then(response => {
            response.data.excluido = response.data.excluido.toString();
            response.data.gerarAgendamentoReplantio = response.data.gerarAgendamentoReplantio ? response.data.gerarAgendamentoReplantio.toString() : "false";
            response.data.final = response.data.final.toString();
            response.data.inicial = response.data.inicial.toString();
            response.data.indicarSituacao = response.data.indicarSituacao ? response.data.indicarSituacao.toString() : "false";
            response.data.sequencia = response.data.sequencia ? response.data.sequencia.toString() : "";
            response.data.formularioAPP_Id = !response.data.formularioAPP_Id ? "" : response.data.formularioAPP_Id.toString();
            response.data.tipoRequerimentoEtapaDocumentos = response.data.tipoRequerimentoEtapaDocumentos.map(documento => {
                documento.id = documento.id.toString();
                documento.documento_Id = documento.documento_Id.toString();
                documento.obrigatorio = documento.obrigatorio.toString();
                return documento;
            });
            response.data.permitirProrrogar = response.data.permitirProrrogar ? response.data.permitirProrrogar.toString() : "false";
            setEtapa(response.data);
        }).catch(ex => showMessage("Aviso", ex.message, "error", null))
            .finally(f => setLoading(false));
    }

    //Função de adicionar ou editar uma nova etapa
    const onSubmit = () => {
        const _errors = validarCampos(etapa, camposObrigatorios);
        setErrors(_errors[0]);
        if (_errors[1].length)
            return;

        setLoading(true);
        const _etapa = { ...etapa };

        _etapa.excluido = _etapa.excluido == "true";
        _etapa.final = _etapa.final == "true";
        _etapa.gerarAgendamentoReplantio = _etapa.gerarAgendamentoReplantio == "true";
        _etapa.inicial = _etapa.inicial == "true";
        _etapa.permitirProrrogar = _etapa.permitirProrrogar == "true";
        _etapa.indicarSituacao = _etapa.indicarSituacao == "true";
        _etapa.tipoRequerimento_Id = tipoRequerimento.id;
        delete _etapa.tipoRequerimentoEtapaAcos;
        delete _etapa.tipoRequerimentoEtapaProximaAcaos;
        if (_etapa.id) {
            tipoRequerimento_api.putTipoRequerimentoEtapa(_etapa).then(response => {
                showMessage("Sucesso", "Sucesso ao atualizar a etapa!", 'success', () => {
                    toggleFormContainer();
                    loadEtapas();
                    setCamposObrigatorios(camposObrigatorios.filter(value => value.name != "formularioAPP_Id"));
                });
            }).catch(ex => {
                showMessage("Erro", ex.message, 'error', null);
            }).finally(f => setLoading(false));
        } else {
            tipoRequerimento_api.postTipoRequerimentoEtapa(_etapa).then(response => {
                showMessage("Sucesso", "Sucesso ao cadastrar a etapa!", 'success', () => {
                    toggleFormContainer();
                    loadEtapas();
                    setCamposObrigatorios(camposObrigatorios.filter(value => value.name != "formularioAPP_Id"));
                });
            }).catch(ex => {
                showMessage("Erro", ex.message, 'error', null);
            }).finally(f => setLoading(false));
        }
    }

    //onChange para o formulario
    const onChangeFormulario = (value, e) => {
        setEtapa({
            ...etapa,
            [e.name]: value ? value.value : null,
        });

    }

    useEffect(() => {
        loadDocumentos();
        loadFormularios();
        if (!tipoRequerimento.tipoRequerimentoEtapas) {
            loadEtapas();
        }
    }, []);

    return (
        <>
            <h5 className='mb-3 d-flex align-items-center justify-content-between'>Etapas
                {editavel &&
                    <Button color='success' onClick={toggleFormContainer}>+ Adicionar</Button>
                }
            </h5>
            <ModalCustomized btnClose={true} isOpen={visibleModal} toggle={toggleModal} title={"Documentos"}>
                <Row>
                    {editavel &&
                        (<>
                            <Col md="12" lg="8">
                                <TextField
                                    label={"* Documento"}
                                    name={"documento_Id"}
                                    onChange={onChangeDocumento}
                                    type={"select"}
                                    searchable
                                    options={documentos.map(value => { return { value: value.id, label: value.identificacao } })}
                                    value={
                                        documentos.filter(doc => doc.id === documento.documento_Id).map(value => { return { value: value.id, label: value.identificacao } })
                                    }
                                    invalid={!!errorsDocumento.documento_Id}
                                    disabled={!editavel}
                                />
                            </Col>
                            <Col md="12" lg="4">
                                <TextField
                                    type={"radio"}
                                    label="* Obrigatorio"
                                    name={"obrigatorio"}
                                    options={
                                        [
                                            { label: "Sim", value: "true" },
                                            { label: "Não", value: "false" }
                                        ]
                                    }
                                    onChange={onChangeObrigatorioDocumento}
                                    value={documento.obrigatorio}
                                    invalid={!!errorsDocumento.obrigatorio}
                                    disabled={!editavel}
                                />
                            </Col>
                            <Col md="12" className='d-flex align-items-center justify-content-center mb-4 '>
                                <Button color={"secondary"} className='me-4' onClick={() => {
                                    setDocumento(initialStateDocumento(etapa.id));
                                }
                                }>
                                    cancelar
                                </Button>
                                {editavel &&
                                    <Button onClick={onSubmitDocumento} color={documento.id ? "warning text-white" : 'success'}>
                                        {documento.id ? <> <FontAwesomeIcon icon={faEdit} />  Editar</> : "+ Adicionar"}
                                    </Button>
                                }
                            </Col>
                        </>)}
                    <Col md="12" className='d-flex align-items-center justify-content-center'>
                        <TabelaListagem title='Lista de documentos' headers={headersDocumentos} actions={actionsDocumentos} items={etapa.tipoRequerimentoEtapaDocumentos} />
                    </Col>
                </Row>
            </ModalCustomized>
            <div className={`formContainer ${visibleContainer ? "" : "close"}`}>
                <Row className='mb-4'>
                    <Col md="12" lg="6">
                        <TextField
                            label={"* Identificação"}
                            name={"identificacao"}
                            maxLength={100}
                            onChange={onChange}
                            value={etapa.identificacao}
                            invalid={!!errors.identificacao}
                            disabled={!editavel}
                        />
                    </Col>
                    <Col md="12" lg="3">
                        <TextField
                            label={"Prazo em dias"}
                            name={"prazoDias"}
                            onChange={onChange}
                            value={etapa.prazoDias}
                            invalid={!!errors.prazoDias}
                            disabled={!editavel}
                        />
                    </Col>
                    <Col md="12" lg="3">
                        <TextField
                            label={"Sequência"}
                            name={"sequencia"}
                            onChange={onChange}
                            value={etapa.sequencia}
                            invalid={!!errors.sequencia}
                            disabled={!editavel}
                        />
                    </Col>
                    <Col md="12" lg={etapa.responsavel == "Fiscal" ? "4" : "8"}>
                        <TextField
                            label={"* Responsavel"}
                            name={"responsavel"}
                            onChange={onChangeResponsavel}
                            type={"select"}
                            options={[
                                { label: "Selecione uma opção", value: "" },
                                { label: "Gestor", value: "Gestor" },
                                { label: "Fiscal", value: "Fiscal" },
                                { label: "Requerente", value: "Requerente" },
                                { label: "Sistema", value: "Sistema" },
                            ]}
                            value={etapa.responsavel}
                            invalid={!!errors.responsavel}
                            disabled={!editavel}
                        />
                    </Col>
                    {
                        etapa.responsavel == "Fiscal" &&
                        <Col md="12" lg="4">
                            <TextField
                                label={"* Formulário de vistoria"}
                                name={"formularioAPP_Id"}
                                type={"select"}
                                options={formularios.map(value => { return { value: value.id.toString(), label: value.identificacao } })}
                                searchable
                                onChange={onChangeFormulario}
                                value={formularios.filter(formulario => formulario.id.toString() === etapa.formularioAPP_Id).map(value => { return { value: value.id.toString(), label: value.identificacao } })}
                                invalid={!!errors.formularioAPP_Id}
                                disabled={!editavel}
                            />
                        </Col>
                    }
                    <Col md="12" lg="4">
                        <Button className='w-100 mt-2' color='primary' onClick={toggleModal}>
                            Documentos
                        </Button>
                    </Col>
                    <Col md="12" lg="12">
                        <TextField
                            type={"textarea"}
                            label="Orientações"
                            name={"orientacoes"}
                            maxLength={300}
                            onChange={onChange}
                            value={etapa.orientacoes}
                            invalid={!!errors.orientacoes}
                            disabled={!editavel}
                        />
                    </Col>
                    <Col md="12" lg={etapa.final == "true" ? "4" : "6"}>
                        <TextField
                            type={"radio"}
                            label="* Etapa inicial"
                            name={"inicial"}
                            options={
                                [
                                    { label: "Sim", value: "true" },
                                    { label: "Não", value: "false" }
                                ]
                            }
                            onChange={onChange}
                            value={etapa.inicial}
                            invalid={!!errors.inicial}
                            disabled={!editavel}
                        />
                    </Col>
                    <Col md="12" lg={etapa.final == "true" ? "4" : "6"}>
                        <TextField
                            type={"radio"}
                            label="* Etapa final"
                            name={"final"}
                            options={
                                [
                                    { label: "Sim", value: "true" },
                                    { label: "Não", value: "false" }
                                ]
                            }
                            onChange={onChange}
                            value={etapa.final}
                            invalid={!!errors.final}
                            disabled={!editavel}
                        />
                    </Col>
                    {etapa.final == "true" &&
                        <Col md="12" lg="4">
                            <TextField
                                type={"radio"}
                                label="Gerar Agendamento Replantio"
                                name={"gerarAgendamentoReplantio"}
                                options={
                                    [
                                        { label: "Sim", value: "true" },
                                        { label: "Não", value: "false" }
                                    ]
                                }
                                onChange={onChange}
                                value={etapa.gerarAgendamentoReplantio}
                                disabled={!editavel}
                            />
                        </Col>
                    }
                    <Col md="12" lg={etapa.final == "true" ? "4" : "6"}>
                        <TextField
                            type={"radio"}
                            label="* Permitir prorrogar prazo"
                            name={"permitirProrrogar"}
                            options={
                                [
                                    { label: "Sim", value: "true" },
                                    { label: "Não", value: "false" }
                                ]
                            }
                            onChange={onChange}
                            value={etapa.permitirProrrogar}
                            invalid={!!errors.permitirProrrogar}
                            disabled={!editavel}
                        />
                    </Col>
                    <Col md="12" lg={etapa.final == "true" ? "4" : "6"}>
                        <TextField
                            type={"radio"}
                            label="* Indicar Situação"
                            name={"indicarSituacao"}
                            options={
                                [
                                    { label: "Sim", value: "true" },
                                    { label: "Não", value: "false" }
                                ]
                            }
                            onChange={onChange}
                            value={etapa.indicarSituacao}
                            invalid={!!errors.indicarSituacao}
                            disabled={!editavel}
                        />
                    </Col>
                    <Col className='d-flex align-items-center justify-content-center' md="12" lg="12">
                        <Button className='me-4' color={"secondary"} onClick={toggleFormContainer}>
                            Cancelar
                        </Button>
                        {editavel &&
                            <Button color={etapa.id ? "warning text-white" : 'success'} onClick={onSubmit}>
                                {etapa.id ? <><FontAwesomeIcon icon={faEdit} /> Editar</> : "+ Adicionar"}
                            </Button>
                        }
                    </Col>
                </Row>
            </div>
            <TabelaListagem actions={actions} title={"Lista de etapas"} options={{ print: false, search: true, pagination: true }} headers={headers} items={tipoRequerimento.tipoRequerimentoEtapas} />
        </>
    )
}